module.exports = __webpack_public_path__ + "static/media/star_yhe-x_90.d40d0afe.png";